// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseEntity from './entities/case.json';
import caseMenu from '../pages/case/menu.json';
import caseFullForm from '../pages/case/forms/full.json';
import caseContextForm from '../pages/case/forms/context.json';
import caseMiniForm from '../pages/case/forms/mini.json';
import caseLookupForm from '../pages/case/forms/lookup.json';
import caseTableView from '../pages/case/views/table.json';
import caseStagesView from '../pages/case/views/stages.json';
import caseCardsView from '../pages/case/views/cards.json';
import caseInlineView from '../pages/case/views/inline.json';
import caseBacklogView from '../pages/case/views/backlog.json';
import caseSplitView from '../pages/case/views/split.json';
import caseCalendarView from '../pages/case/views/calendar.json';
import caseDashboardView from '../pages/case/views/dashboard.json';

/** Тип запису «Справа» зі сторінками пакета: меню, форми та подання з pages/case/. */
export const caseDefinition: IRecordTypeDefinition = {
  ...caseEntity,
  views: assembleViewSet({
      table: caseTableView,
      stages: caseStagesView,
      cards: caseCardsView,
      inline: caseInlineView,
      backlog: caseBacklogView,
      split: caseSplitView,
      calendar: caseCalendarView,
      dashboard: caseDashboardView,
  }),
  form: caseFullForm,
  forms: { full: caseFullForm, context: caseContextForm, mini: caseMiniForm, lookup: caseLookupForm },
  menu: caseMenu,
} as IRecordTypeDefinition;
